// @ts-nocheck
import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  SelectChangeEvent,
  Typography,
  Switch,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import * as Yup from "yup";
import { isString, useFormik } from "formik";
import {
  useAddSubscriptionMutation,
  useUpdateSubscriptionMutation,
  useLazyGetSubscriptionByIdQuery,
} from "../../services/subscription";
import DeleteIcon from "@mui/icons-material/Delete";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody, Subscription } from "../../types/General";
import { Loader, showError, showToast } from "../../constants";
import { isNumber } from "../../utils/validations";
import {
  ARABIC_FIELD_CLASS,
  arabicInputProps,
  withArabicFieldClass,
} from "../../utils/arabicField";
import useTranslation from "../../hooks/Translation";
import {
  useAddDiscountMutation,
  useLazyGetUserDropDownQuery,
  useLazyGetDiscountByIdQuery,
  useUpdateDiscountMutation,
} from "../../services/discount";
import moment from "moment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

const AddDiscount = () => {
  const { id } = useParams();
  const location = useLocation();
  const { state } = location;
  const [addDiscount] = useAddDiscountMutation();
  const [updateSubscription] = useUpdateSubscriptionMutation();
  const [discountDetails] = useLazyGetDiscountByIdQuery();
  const [updateDiscount] = useUpdateDiscountMutation();
  const navigate = useNavigate();
  const [subsById, setSubsById] = useState<any>();
  const [error, setError] = useState(false);
  const [discountType, setDiscountType] = useState("");

  const [allUsers] = useLazyGetUserDropDownQuery();
  const [userData, setUserData] = useState<any[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<any>([]);
  const [selectedType, setSelectedType] = useState("1");
  const ids = selectedUsers.map((item: any) => item._id);

  const [selected, setSelected] = useState("");

  const [featureEnabled, setFeatureEnabled] = useState(false); // Set to true or false based on your logic
  const [loading, setLoading] = useState(false);

  const handleSwitchChange = () => {
    setFeatureEnabled(!featureEnabled);
    // Add any other logic you want to execute when the switch changes state
  };

  const handleTypeChange = (event: SelectChangeEvent) => {
    setDiscountType(event.target.value as string);
  };

  const handleUserTypeChange = (event: SelectChangeEvent) => {
    setSelectedType(event.target.value as string);
    setSelectedUsers([]);
    setSelected("");
  };



  const handleUserChange = (event: SelectChangeEvent, value: any[]) => {
    setSelectedUsers(value);
  };

  const handleCodeChange = (event: SelectChangeEvent) => {
    setSelected(event.target.value as string);
  };

  const [switchValue, setSwitchValue] = useState(1);
  console.log(switchValue);

  const translate = useTranslation();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      price: subsById?.discountValue || "",
      planName: subsById?.discountName || "",
      planName_ar: subsById?.discountName_ar || "",
      minAmount: subsById?.minAmountToApply || "",
      // maximumDiscountAmount: subsById?.maximumDiscountAmount || "",
      startDate: id ? moment(subsById?.startDate).format("YYYY-MM-DD") : "",
      endDate: id ? moment(subsById?.endDate).format("YYYY-MM-DD") : "",
    },
    validationSchema: Yup.object({
      price: Yup.string()
        .required(translate?.error?.required || "")
        .max(20, translate?.error?.maxValidation20 || ""),
      planName: Yup.string()
        .required(translate?.error?.required || "")
        .max(20, translate?.error?.maxValidation20 || "")
        .min(2, translate?.error?.minValidation2 || ""),
      planName_ar: Yup.string()
        .required(translate?.error?.required || "")
        .max(20, translate?.error?.maxValidation20 || "")
        .min(2, translate?.error?.minValidation2 || "")
        .test("no-spaces-only", translate?.error?.noSpacesOnly || "", (value) => {
          return value ? value.trim().length > 0 : true;
        }),
      minAmount: Yup.string()
        .required(translate?.error?.required || "")
        .max(20, translate?.error?.maxValidation20 || ""),
      startDate: Yup.string().required(translate?.error?.required || ""),
      endDate: Yup.string().required(translate?.error?.required || ""),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      const ids = selectedUsers.map((item: any) => item._id);

      const parseAmount = (value: string | number) =>
        Number(String(value ?? "").replace(/,/g, ""));

      const data = {
        discountName: formik?.values?.planName,
        discountName_ar: formik?.values?.planName_ar,
        discountType: Number(discountType),
        discountValue: parseAmount(formik?.values?.price),
        minAmountToApply: parseAmount(values.minAmount),
        users: selected === "1" ? ids : [],
        startDate: values.startDate,
        endDate: values.endDate,
        userType: Number(selectedType),
        forAllUsers: selected === "2" ? true : false,
      };

      if (!discountType || !selectedType || !selected) {
        setError(true);
        formik.setSubmitting(false);
        return;
      }

      if (id && id !== "add") {
        try {
          setLoading(true);
          let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;
          const response = await updateDiscount({
            id: id,
            encryptedBody,
          }).unwrap();
          if (response?.statusCode === 200) {
            setLoading(false);
            showToast(translate?.manageDiscount?.promoCodeUpdated || "Promotional Code Updated successfully");
            window.setTimeout(() => navigate("/manage-discount"), 0);
          } else {
            setLoading(false);
            showError(response?.message || "");
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || "");
          console.log(error);
        }
      } else {
        try {
          setLoading(true);
          let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;
          const response = await addDiscount(encryptedBody).unwrap();
          if (response?.statusCode === 200) {
            setLoading(false);
            showToast(translate?.manageDiscount?.promoCodeAdded || "Promotional Code Added Successfully");
            formik.resetForm();
            window.setTimeout(() => navigate("/manage-discount"), 0);
          } else {
            setLoading(false);
            showError(response?.message || "");
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || "");
          console.log(error);
        }
      }
    },
  });

  const formatNumberWithCommas = (number: any) => {
    if (number > 0) {
      const formattedNumber = number.toLocaleString("en-US");
      return `${formattedNumber}`;
    }
    return "";
  };

  const getCategoryDetail = async (id: string | undefined) => {
    try {
      const res: any = await discountDetails({ id: id }).unwrap();
      if (res?.statusCode === 200) {
        setSubsById(res?.data);
        setDiscountType(String(res?.data?.discountType));
        setSelectedType(String(res?.data?.userType));

        if (res?.data?.users?.length) {
          setSelectedUsers(res?.data?.userDetails);
          setSelected("1");
        } else {
          setSelected("2");
        }
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const getAllUsers = async () => {
    setLoading(true);
    try {
      const res: any = await allUsers({
        query: "",
        type: Number(selectedType),
      }).unwrap();
      if (res?.statusCode === 200) {
        setLoading(false);
        setUserData(res?.data);
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getAllUsers();
  }, [selectedType]);

  useEffect(() => {
    if (id && id !== "add") {
      getCategoryDetail(id);
    }
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_loyout">
        <div className="dashboard">
          {state?.type === "edit" ? (
            <h1 className="mn_hdng">{translate?.manageDiscount?.editPromotionalCode || "Edit Promotional Code"}</h1>
          ) : (
            <h1 className="mn_hdng">{translate?.manageDiscount?.addPromotionalCode || "Add Promotional Code"}</h1>
          )}
          <Button
            className="btn btn_primary"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              window.setTimeout(() => navigate("/manage-discount"), 0);
            }}
          >
            {translate?.main?.Back || "Back"}
          </Button>
        </div>
        <Card className="cards">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {translate?.manageDiscount?.discountName || "Discount Name"} ({translate?.main?.English || "English"})
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="planName"
                      variant="outlined"
                      fullWidth
                      className="text_field"
                      placeholder="Discount Name"
                      onBlur={formik.handleBlur}
                      value={formik.values.planName}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else if (isString(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        formik.touched.planName && formik.errors.planName
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {translate?.manageDiscount?.discountName || "Discount Name"} ({translate?.main?.Arabic || "Arabic"})
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="planName_ar"
                      variant="outlined"
                      fullWidth
                      className={withArabicFieldClass("text_field")}
                      inputProps={arabicInputProps}
                      placeholder="Discount Name"
                      onBlur={formik.handleBlur}
                      value={formik.values.planName_ar}
                      onChange={(val) => {
                        const value = val.target.value;
                        if (value.trim().length === 0 && value.length > 0) {
                          return;
                        }
                        if (isString(value)) {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        formik.touched.planName_ar && formik.errors.planName_ar
                      }
                    />
                  </Grid>
                  {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Discount Code
                  </Typography>
                  <TextField
                    hiddenLabel
                    type={"text"}
                    name="discountCode"
                    variant="outlined"
                    fullWidth
                    className="text_field"
                    placeholder="Discount Code"
                    onBlur={formik.handleBlur}
                    value={formik.values.discountCode}
                    onChange={formik.handleChange}
                    helperText={
                      formik.touched.discountCode && formik.errors.discountCode
                    }
                  />
                </Grid> */}

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {translate?.manageDiscount?.selectDiscountType || "Select Discount Type"}
                    </Typography>

                    <FormControl sx={{ width: "100%" }}>
                      <Select
                        fullWidth
                        className="select_div"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={discountType}
                        // multiple
                        inputProps={{
                          "aria-label": "Without label",
                        }}
                        displayEmpty
                        onChange={handleTypeChange}
                        disabled={id && id !== "add"}
                      >
                        <MenuItem value="" disabled>
                          {translate?.dashboard?.Select || "Select"}
                        </MenuItem>

                        <MenuItem value="1">{translate?.manageDiscount?.percent || "Percent"}</MenuItem>
                        <MenuItem value="2">{translate?.manageDiscount?.flat || "Flat"}</MenuItem>
                      </Select>
                      {error && !discountType ? (
                        <h6 className="err_msg">{translate?.manageDiscount?.pleaseSelectDiscountType || "Please Select Discount Type"}</h6>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </Grid>

                  {/* {discountType === "1" ? (
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Maximum Discount Amount
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="maximumDiscountAmount"
                      variant="outlined"
                      fullWidth
                      className="text_field"
                      placeholder="Discount Value"
                      onBlur={formik.handleBlur}
                      value={formatNumberWithCommas(
                        formik.values.maximumDiscountAmount
                      )}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                        }
                        formik.handleChange(val);
                      }}
                      helperText={
                        formik.touched.maximumDiscountAmount &&
                        formik.errors.maximumDiscountAmount
                      }
                    />
                  </Grid>
                ) : null} */}

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {translate?.manageDiscount?.discountValue || "Discount Value"}
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="price"
                      variant="outlined"
                      fullWidth
                      className="text_field"
                      placeholder="Discount Value"
                      onBlur={formik.handleBlur}
                      value={formatNumberWithCommas(formik.values.price)}
                      onChange={(e) => {
                        let value = e.target.value;

                        // Remove commas if present before validation
                        value = value.replace(/,/g, "");

                        // Check if discount type is 1 and restrict input to 0-100
                        if (discountType === "1") {
                          if (parseFloat(value) > 100) {
                            value = "100";
                          }
                        }

                        // Format the value with commas
                        const formattedValue = formatNumberWithCommas(value);

                        // Update the form value
                        formik.handleChange({
                          target: {
                            name: e.target.name,
                            value: formattedValue,
                          },
                        });
                      }}
                      helperText={formik.touched.price && formik.errors.price}
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {translate?.manageDiscount?.minAmountToApply || "Minimum Amount To Apply"}
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="minAmount"
                      variant="outlined"
                      fullWidth
                      className="text_field"
                      placeholder="Minimum Amount To Apply"
                      onBlur={formik.handleBlur}
                      value={formatNumberWithCommas(formik.values.minAmount)}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                        }
                        formik.handleChange(val);
                      }}
                      helperText={
                        formik.touched.minAmount && formik.errors.minAmount
                      }
                    />
                  </Grid>



                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">{translate?.manageDiscount?.userType || "User Type"}</Typography>

                    <FormControl sx={{ width: "100%" }}>
                      <Select
                        fullWidth
                        className="select_div"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedType}
                        // multiple
                        inputProps={{
                          "aria-label": "Without label",
                        }}
                        displayEmpty
                        onChange={handleUserTypeChange}
                        disabled={id && id !== "add"}
                      >
                        <MenuItem value="" disabled>
                          {translate?.dashboard?.Select || "Select"}
                        </MenuItem>

                        <MenuItem value="1">{translate?.dashboard?.User || "Users"}</MenuItem>
                        <MenuItem value="2">{translate?.main?.Agent || "Agents"}</MenuItem>
                        <MenuItem value="3">{translate?.manageDiscount?.both || "Both"}</MenuItem>
                      </Select>
                      {error && !selected ? (
                        <h6 className="err_msg">{translate?.manageDiscount?.pleaseSelectType || "Please Select Type"}</h6>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {translate?.manageDiscount?.applyCodeFor || "Apply Code For"}
                    </Typography>

                    <FormControl sx={{ width: "100%" }}>
                      <Select
                        fullWidth
                        className="select_div"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selected}
                        // multiple
                        inputProps={{
                          "aria-label": "Without label",
                        }}
                        displayEmpty
                        onChange={handleCodeChange}
                        disabled={id && id !== "add"}
                      >
                        <MenuItem value="" disabled>
                          {translate?.dashboard?.Select || "Select"}
                        </MenuItem>

                        <MenuItem value="1">
                          {selectedType === "2"
                            ? translate?.manageDiscount?.selectedAgents || "Selected Agents"
                            : selectedType === "3"
                              ? translate?.manageDiscount?.selectedUsersAgents || "Selected Users & Agents"
                              : translate?.manageDiscount?.selectedUsers || "Selected Users"}
                        </MenuItem>
                        <MenuItem value="2">
                          {selectedType === "2"
                            ? translate?.manageDiscount?.allAgents || "All Agents"
                            : selectedType === "3"
                              ? translate?.manageDiscount?.allUsersAgents || "All Users & Agents"
                              : translate?.manageDiscount?.allUsers || "All Users"}
                        </MenuItem>
                      </Select>
                      {error && !selected ? (
                        <h6 className="err_msg">{translate?.manageDiscount?.pleaseSelectType || "Please Select Type"}</h6>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </Grid>

                  {selected === "1" ? (
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Typography className="custom_label">
                        {translate?.manageDiscount?.selectUsers || "Select Users"}
                      </Typography>
                      <FormControl sx={{ width: "100%" }}>
                        <Autocomplete
                          multiple
                          className="multi_select_div"
                          options={userData}
                          getOptionLabel={(option) => {
                            const name = option.fullName || "No Name";
                            if (option.email) {
                              return `${name} (${option.email})`;
                            } else if (option.phone) {
                              return `${name} (${option.phone})`;
                            }
                            return name;
                          }}
                          value={selectedUsers}
                          onChange={handleUserChange}
                          renderOption={(props, option) => (
                            <Box component="li" {...props}>
                              <Typography>
                                {option.fullName || "No Name"}
                                {(option.email || option.phone) && (
                                  <Typography component="span" sx={{ color: "text.secondary", ml: 1 }}>
                                    ({option.email || option.phone})
                                  </Typography>
                                )}
                              </Typography>
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              className="autoText"
                              {...params}
                              variant="standard"
                              placeholder={translate?.manageDiscount?.searchUsers || "Search users"}
                            //   error={
                            //     formik.touched.receiverId &&
                            //     Boolean(formik.errors.receiverId)
                            //   }
                            //   helperText={
                            //     formik.touched.receiverId &&
                            //     formik.errors.receiverId
                            //       ? formik.errors.receiverId.toString()
                            //       : ""
                            //   }
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                  ) : null}

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">{translate?.manageDiscount?.startDate || "Start Date"}</Typography>
                    <DatePicker
                      value={formik.values.startDate ? moment(formik.values.startDate, "YYYY-MM-DD") : null}
                      onChange={(newValue) => {
                        if (newValue) {
                          formik.setFieldValue("startDate", moment(newValue).format("YYYY-MM-DD"));
                        } else {
                          formik.setFieldValue("startDate", "");
                        }
                      }}
                      minDate={moment()}
                      format="DD-MM-YYYY"
                      slotProps={{
                        textField: {
                          hiddenLabel: true,
                          className: "text_field",
                          variant: "outlined",
                          fullWidth: true,
                          placeholder: "DD-MM-YYYY",
                          onBlur: formik.handleBlur,
                          name: "startDate",
                          helperText: formik.touched.startDate && formik.errors.startDate,
                          InputProps: {
                            disableUnderline: true,
                            endAdornment: <CalendarTodayIcon sx={{ color: "rgba(0, 0, 0, 0.54)", cursor: "pointer" }} />,
                          },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">{translate?.manageDiscount?.endDate || "End Date"}</Typography>
                    <DatePicker
                      value={formik.values.endDate ? moment(formik.values.endDate, "YYYY-MM-DD") : null}
                      onChange={(newValue) => {
                        if (newValue) {
                          formik.setFieldValue("endDate", moment(newValue).format("YYYY-MM-DD"));
                        } else {
                          formik.setFieldValue("endDate", "");
                        }
                      }}
                      minDate={formik.values.startDate ? moment(formik.values.startDate, "YYYY-MM-DD") : moment()}
                      disabled={!formik.values.startDate}
                      format="DD-MM-YYYY"
                      slotProps={{
                        textField: {
                          hiddenLabel: true,
                          className: "text_field",
                          variant: "outlined",
                          fullWidth: true,
                          placeholder: "DD-MM-YYYY",
                          onBlur: formik.handleBlur,
                          name: "endDate",
                          helperText: formik.touched.endDate && formik.errors.endDate,
                          InputProps: {
                            disableUnderline: true,
                            endAdornment: <CalendarTodayIcon sx={{ color: "rgba(0, 0, 0, 0.54)", cursor: "pointer" }} />,
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                    onClick={() => setError(true)}
                  >
                    {translate?.main?.Save || "Save"}
                  </Button>
                </div>
              </CardContent>
            </form>
          </LocalizationProvider>
        </Card>
      </div>
    </MainContainer>
  );
};

export default AddDiscount;
